import LocalStorage from '../local-storage/LocalStorage'

const ORGANIZATION_ID_KEY = 'organization.id'

const OrganizationStorage = {
  get: (): string | undefined => LocalStorage.get<string>(ORGANIZATION_ID_KEY),
  set: (id: string): void => LocalStorage.set(ORGANIZATION_ID_KEY, id),
  clear: (): void => LocalStorage.remove(ORGANIZATION_ID_KEY),
}

export default OrganizationStorage
